const TRANSIENT_NUMERIC_VALUES = new Set(['', '-', '.', '-.']);

export const isTransientNumericValue = (value: string): boolean => {
  return TRANSIENT_NUMERIC_VALUES.has(value.trim());
};

export const parseTransientAwareNumber = (value: string): number | null => {
  const trimmedValue = value.trim();

  if (isTransientNumericValue(trimmedValue)) {
    return null;
  }

  const parsedValue = Number(trimmedValue);
  return isNaN(parsedValue) ? null : parsedValue;
};
